const EventBus =
    {
        install(Vue, options) {

            Vue.prototype.$broadcast = function (to, data, callback) {

                window.postMessage({to: to, data: data}, location.href);

            };

            Vue.prototype.$listen = function (listen_for, callback) {

                window.addEventListener("message", function (event) {
                    if (event.data.to === listen_for) {
                        callback(event.data.data);
                    }
                });

            };

        }

    };

export default EventBus;


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/EventBus.js